import { Sparkles } from 'lucide-react';

/**
 * Centered empty state used across tables, tabs, lists. Pass a Lucide icon
 * component (not an element) to customize the illustration.
 */
export default function EmptyState({ title, body, action, icon: Icon = Sparkles }) {
  return (
    <div className="card text-center py-14 px-6 bg-white">
      <div className="mx-auto mb-4 h-14 w-14 rounded-2xl bg-gradient-to-br from-brand-500/15 to-cyan-500/15 text-brand-600 flex items-center justify-center ring-1 ring-brand-100">
        <Icon className="w-7 h-7" strokeWidth={1.75} />
      </div>
      <h3 className="text-lg font-semibold text-ink-900">{title}</h3>
      {body && (
        <p className="text-sm text-ink-400 mt-2 max-w-md mx-auto leading-relaxed">{body}</p>
      )}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
